export const API_ENDPOINT = "https://solden-api-production.up.railway.app";

// export const API_ENDPOINT = 'http://localhost:3002';

export const BREAKPOINT = `@media (max-width: 768px)`;
